/*---------------------------------------------------------------------------------------------
 *  Copyright (c) Microsoft Corporation. All rights reserved.
 *  Licensed under the MIT License. See License.txt in the project root for license information.
 *--------------------------------------------------------------------------------------------*/
import { Module, Node } from '@msdyn365-commerce-modules/utilities';
import * as React from 'react';
import { ITabViewProps } from './citta-tabs';

const tabView: React.FC<ITabViewProps> = props => {
    const { heading, TabContainer, tabHeaders, tabContents,headerMobileSection, renderMobileHeader, isMobileView, tabMobileHeaders } = props;
    if (!props.heading && !props.tabHeaders && !props.tabContents) {
        props.context.telemetry.error('Tab content is empty, module wont render');
        return null;
    }
    if (isMobileView) {
        return (
            <Module {...TabContainer}>
                <Node {...props.headerSection}>
                    <Node {...headerMobileSection}>
                {renderMobileHeader}
                {tabMobileHeaders}
                </Node>
                </Node>
                <Node {...props.tabItemContainer}>
                    {tabContents}
                </Node>
            </Module>

        );
    } else {
        return (
            <Module {...TabContainer}>
                <Node {...props.headerSection}>
                    {heading}
                </Node>

                <Node {...props.tabsSection}>
                    {tabHeaders}
                </Node>

                <Node {...props.tabItemContainer}>
                    {tabContents}
                </Node>
            </Module>
        );
    }

};

export default tabView;